import DataBinder from "../DataBinder.js"
import SwapPage from "../SwapPage.js"

import SpeedFactory from "../GameUI/SpeedFactory.js"
import GameUI from "../GameUI/GameUI.js"
import Level from "../Level.js"
export default class GameController {

  constructor(app) {
    this.app = app;
    this.speed = null;
    this.gameUI = new GameUI();
  }
  show(path, model) {
    let pageId = "Game";

    //needs to be before Phaser game create
    const swapPage = new SwapPage();
    swapPage.swapPage(pageId);

    model = this.load(path);

    const dataBinder = new DataBinder();
    dataBinder.populate(pageId, model);

  }
  hide() {
    if (this.speed) this.speed.destroy();
  }

  load(path) {
    const app = this.app;
    const userdata = app.userdata;
    const config = app.config;
    const audio = app.audio;
    const debug = (config && config.DebugMode) || app.debug;
    const gameServerPreferred = userdata.gameServerPreferred;
    const SocketIOUrl = config.SocketIOUrl;

    //todo: pharse path for
    const params = path.split("/");
    const mode = params[1] || "Classic";
    const level = params[2];
    const server = params[3] ? decodeURIComponent(params[3]) : (gameServerPreferred || SocketIOUrl);


    if (this.speed) this.speed.destroy();

    const speedFactory = new SpeedFactory();
    const speed = speedFactory.create(mode, level, server, userdata, debug);
    speed.onMessage3 = this.onMessage.bind(this);

    const quality = userdata.quality;
    const useCanvas = userdata.useCanvas;
    const mute = userdata.mute;
    const gameUI = this.gameUI;

    gameUI.settings(null, audio, quality, useCanvas, mute);
    gameUI.startGame({ speed: speed, deck: userdata.deck, background: userdata.background });

    this.speed = speed;

    const model = {}
    return model;

  }
  onMessage(message, value, location, player) {
    const app = this.app;
    const userdata = app.userdata;
    const achievements = app.achievements;
    const speed = this.speed;

    if (message === "start") {

    }

    if (message === "gameover") {
      if (speed.state === "GameOver") {

        //recored stats
        this.recordStats(speed, userdata);

        //update level
        this.updateLevel(userdata);

        //recored Ranked games
        this.recordRankedGame(speed);

        //check for achievements
        achievements.checkForAchievementAndReward(userdata);

        //award coins
        let coins = this.awardCoins(speed, userdata);

        //save userdata;
        app.save();

        // //collect data for end game UI
        // let model =this.getGameOverModel(speed);

        // this.winTimerDisplay = setTimeout(function () {
        //   //show game over page
        //   app.route.navatage("GameOver", model);
        // }, 1000);
      }
    }
  }
  getGameOverModel(speed) {
    //collect data for end game UI
    let blockedCount = 0;
    let maxStreakCount = 0;
    if (speed.PlayerTop && speed.PlayerTop.isLocal) {
      blockedCount = speed.blockedCountTop;
      maxStreakCount = speed.maxStreakCountTop;
    } else {
      blockedCount = speed.blockedCountBottom;
      maxStreakCount = speed.maxStreakCountBottom;
    }
    let state = speed.state;
    let totalTime = speed.elaspedTime;
    let minutes = Math.floor(totalTime / 60);
    let seconds = Math.round((totalTime - minutes * 60) * 100) / 100;
    let gameOverTime = minutes + ":" + seconds;
    let blockCount = blockedCount;
    let streaks = maxStreakCount;
    let winnerMsg = speed.winnerMsg;
    //let coinsEarned = coins;


    let model = {
      state: state,
      gameOverMessage: winnerMsg,
      gameOverTime: gameOverTime,
      blocks: blockCount,
      streaks: streaks,
      achievements: newAchievements,
      //coinsEarned: coinsEarned,
    }
    return model;
  }
  updateLevel(userdata) {
    //get and save level
    const level = new Level().getLevelFromExp(userdata.stats["win"]);
    userdata.level = level;
  }
  awardCoins(speed, userdata) {
    let coinsReward = 0;
    if (speed.winner.isLocal) {
      coinsReward = 3;
      switch (speed.level) {
        case "Easy": coinsReward = 1; break;
        case "Medium": coinsReward = 1; break;
        case "Hard": coinsReward = 2; break;
        case "CrazyNinja": coinsReward = 2; break;
        case "InsaneMonkey": coinsReward = 3; break;
        case "UltraCheetah": coinsReward = 3; break;
        case "Impossible": coinsReward = 4; break;
        case "Local": coinsReward = 2; break;
        case "Online": coinsReward = 2; break;
        default:
      }

    }
    userdata.coins = userdata.coins + coinsReward || coinsReward;
    return coinsReward;
  }
  recordRankedGame(speed) {
    let app = this.app;
    //win
    if (speed.isRanked && speed.winner?.isLocal) {
      //send win to server (if online game)
      if (speed.isRanked) {
        app.gamification.ReportRankedGame(null, speed.matchId, 0, speed.winner.id, speed.loser.id, 1, speed.elaspedTime, 'html');
      }
    }
    //lose
    if (speed.isRanked && speed.loser?.isLocal && !speed.winner?.isLocal) {
      app.gamification.ReportRankedGame(null, speed.matchId, 0, speed.loser.id, speed.winner.id, 0, speed.elaspedTime, 'html');
    }
  }
  recordStats(speed, userdata) {
    if (speed.state !== "GameOver") return;

    let level = speed.level;
    if (!userdata.stats) userdata.stats = {};
    if (!userdata.sessionStats) userdata.sessionStats = {};

    userdata.stats["games_played"] = (userdata.stats["games_played"] || 0) + 1;


    let results = "";
    if (speed.winner === "tie") results = "tie";
    if (speed.winner?.isLocal) results = "win";
    if (speed.loser?.isLocal && !speed.winner?.isLocal) results = "lose";

    //tie
    if (results === "tie") {
      userdata.stats["tie"] = (userdata.stats["tie"] || 0) + 1;
      userdata.sessionStats["tie"] = (userdata.sessionStats["tie"] || 0) + 1;
      userdata.stats["tie_" + level] = (userdata.stats["tie_" + level] || 0) + 1;
    }
    let blockedCount = 0;
    let maxStreakCount = 0;
    if (speed.PlayerTop && speed.PlayerTop.isLocal) {
      blockedCount = speed.blockedCountTop;
      maxStreakCount = speed.maxStreakCountTop;
    } else {
      blockedCount = speed.blockedCountBottom;
      maxStreakCount = speed.maxStreakCountBottom;
    }
    //win
    if (results === "win") {

      userdata.stats["win"] = (userdata.stats["win"] || 0) + 1;
      userdata.stats["win_" + level] = (userdata.stats["win_" + level] || 0) + 1;
      userdata.stats["win_streak"] = (userdata.stats["win_streak"] || 0) + 1;
      userdata.stats["win_streak_" + level] = (userdata.stats["win_streak_" + level] || 0) + 1;
      userdata.stats["lose_streak"] = 0;
      userdata.stats["lose_streak_" + level] = 0;
      userdata.stats["total_blockedCount"] = (userdata.stats["total_blockedCount"] || 0) + blockedCount;

      userdata.sessionStats["win"] = (userdata.sessionStats["win"] || 0) + 1;
      userdata.sessionStats["win_" + level] = (userdata.sessionStats["win_" + level] || 0) + 1;
      userdata.sessionStats["win_streak"] = (userdata.sessionStats["win_streak"] || 0) + 1;
      userdata.sessionStats["win_streak_" + level] = (userdata.sessionStats["win_streak_" + level] || 0) + 1;
      userdata.sessionStats["lose_streak"] = 0;
      userdata.sessionStats["lose_streak_" + level] = 0;
      userdata.sessionStats["total_blockedCount"] = (userdata.sessionStats["total_blockedCount"] || 0) + blockedCount;

      if (!userdata.stats["fastestWinTime"])
        userdata.stats["fastestWinTime"] = speed.elaspedTime;

      if (userdata.stats["fastestWinTime"] > speed.elaspedTime)
        userdata.stats["fastestWinTime"] = speed.elaspedTime;

      if (!userdata.stats["fastestWinTime_" + level])
        userdata.stats["fastestWinTime_" + level] = speed.elaspedTime;

      if (userdata.stats["fastestWinTime_" + level] > speed.elaspedTime) {
        userdata.stats["fastestWinTime_" + level] = speed.elaspedTime;
        userdata.sessionStats["lastGame_newFastestTime"] = speed.elaspedTime;
      } else {
        userdata.sessionStats["lastGame_newFastestTime"] = null;
      }

      userdata.sessionStats["lastGame_LastCardPlayed"] = (speed.lastCardPlayed != null) ? speed.lastCardPlayed.value : null;
      userdata.sessionStats["lastGame_PullCount"] = speed.pullCount;
      userdata.sessionStats["lastGame_Winner"] = speed.winner.name;
      userdata.sessionStats["lastGame_Winner_isLocal"] = true;
      userdata.sessionStats["lastGame_Level"] = level;
      userdata.sessionStats["lastGame_blockedCount"] = blockedCount;
      userdata.sessionStats["lastGame_maxStreakCount"] = maxStreakCount;
      userdata.sessionStats["lastGame_WinTime"] = speed.elaspedTime;

    }
    //lose
    if (results === "lose") {

      userdata.stats["lose"] = (userdata.stats["lose"] || 0) + 1;
      userdata.stats["lose_" + level] = (userdata.stats["lose_" + level] || 0) + 1;
      userdata.stats["win_streak"] = 0;
      userdata.stats["win_streak_" + level] = 0;
      userdata.stats["lose_streak"] = (userdata.stats["lose_streak"] || 0) + 1;
      userdata.stats["lose_streak_" + level] = (userdata.stats["lose_streak_" + level] || 0) + 1;
      userdata.stats["total_blockedCount"] = (userdata.stats["total_blockedCount"] || 0) + blockedCount;

      userdata.sessionStats["lose"] = (userdata.sessionStats["lose"] || 0) + 1;
      userdata.sessionStats["lose_" + level] = (userdata.sessionStats["lose_" + level] || 0) + 1;
      userdata.sessionStats["win_streak"] = 0;
      userdata.sessionStats["win_streak_" + level] = 0;
      userdata.sessionStats["lose_streak"] = (userdata.sessionStats["lose_streak"] || 0) + 1;
      userdata.sessionStats["lose_streak_" + level] = (userdata.sessionStats["lose_streak_" + level] || 0) + 1;
      userdata.sessionStats["total_blockedCount"] = (userdata.sessionStats["total_blockedCount"] || 0) + blockedCount;


      userdata.sessionStats["lastGame_LastCardPlayed"] = (speed.lastCardPlayed != null) ? speed.lastCardPlayed.value : null;
      userdata.sessionStats["lastGame_PullCount"] = speed.pullCount;
      userdata.sessionStats["lastGame_Winner"] = speed.winner.name;
      userdata.sessionStats["lastGame_Winner_isLocal"] = false;
      userdata.sessionStats["lastGame_Level"] = level;
      userdata.sessionStats["lastGame_blockedCount"] = blockedCount;
      userdata.sessionStats["lastGame_maxStreakCount"] = maxStreakCount;

    }
  }

}